import http from "../utils/http";
// 주소 가져오기
export const addressByCoord = ({ latitude, longitude }) => {
  return new Promise((resolve, reject) => {
    http
      .get("/maps/address-by-coord", {
        params: {
          latitude, longitude
        }
      })
      .then((res) => {
        resolve(res.data.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const addressToCoord = ({ address }) => {
  return new Promise((resolve, reject) => {
    http
      .get("/maps/address-to-coord", {
        params: {
          address
        }
      })
      .then((res) => {
        resolve(res.data.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};